export default {
  navTitle: {
    en: '{firstName}\'s Profile',
  },
  resubscribe: {
    en: 'Resubscribe',
  },
  sendGift: {
    en: 'Send a gift',
  },
  subscriptionStatus: {
    en: 'Subscription status',
  },
  upgradeSubscription: {
    en: 'Upgrade',
  },
  upgradeYourPlan: {
    en: 'Upgrade your plan',
  },
  prepaidPlans: {
    en: 'Prepay and save',
  },
  unpauseSubscription: {
    en: 'Unpause',
  },
  inviteFriends: {
    en: 'Invite friends',
  },
  retakeQuiz: {
    en: 'Retake quiz',
  },
  personalInfo: {
    en: 'Personal info',
  },
  billingAndShipping: {
    en: 'Billing & shipping',
  },
  changePassword: {
    en: 'Change password',
  },
  logout: {
    en: 'Logout',
  },
  tracking: {
    en: 'Tracking',
  },
  myQueue: {
    en: 'My queue',
  },
}
